module.exports = __webpack_public_path__ + "static/media/norte_medio.8e22d77e.mp4";